import InfoSvg from "components/icons/24/notifications/info.svg";
import WarningSvg from "components/icons/24/notifications/warning-triangle.svg";
import TickCircleSvg from "components/icons/24/notifications/tick-circle.svg";
import { classes } from "lib/actions/util";
import React from "react";

export default function MessageBanner({
  customIcon,
  customIconClass,
  messageType,
  colourWidth,
  children,
}: {
  customIcon?: React.ReactNode;
  customIconClass?: string;
  messageType: MessageType;
  colourWidth: "sm" | "md" | "lg";
  children: React.ReactNode;
}) {
  return (
    <div className="flex h-full w-full rounded-lg border border-neutral-300">
      <div
        className={classes(
          "flex items-center justify-center rounded-bl-lg rounded-tl-lg p-2",
          messageType == MessageType.Info && "bg-sky-100 text-sky-500",
          messageType == MessageType.Warning && "bg-amber-100 text-amber-500",
          messageType == MessageType.Error && "bg-red-100 text-red-500",
          messageType == MessageType.Success && "bg-green-200 text-green-500",
          colourWidth == "sm" && "w-10",
          colourWidth == "md" && "w-16",
          colourWidth == "lg" && "w-24",
        )}
      >
        <div className={classes(!customIconClass && "w-6", customIconClass)}>
          {customIcon ? (
            customIcon
          ) : messageType == MessageType.Info ? (
            <InfoSvg />
          ) : messageType == MessageType.Success ? (
            <TickCircleSvg />
          ) : (
            <WarningSvg />
          )}
        </div>
      </div>
      <div
        className={classes(
          "flex w-full flex-col rounded-r-lg bg-white",
          (colourWidth == "sm" || colourWidth == "md") && "p-2.5 px-4",
          colourWidth == "lg" && "p-5 px-6",
        )}
      >
        <div>{children}</div>
      </div>
    </div>
  );
}

export enum MessageType {
  Info,
  Warning,
  Error,
  Success,
}
